import { createContext } from "react";
import type { OptionsMap, RequiredSet } from "../hooks/useTemplateOptions";
import type { AssetsByCategory } from "../hooks/usePropertySurveyAssets";

/** Context to pass the template options map to deeply nested field renderers */
export const OptionsMapContext = createContext<OptionsMap>({});
/** Context to pass the set of required field titles */
export const RequiredSetContext = createContext<RequiredSet>(new Set());
/** Context to pass asset photos grouped by category */
export const AssetsByCategoryContext = createContext<AssetsByCategory>({});
/** Context to signal expand/collapse all — version increments on each toggle */
export const ExpandAllContext = createContext<{ expanded: boolean; version: number }>({
  expanded: false,
  version: 0,
});
/** Context to hide answered questions */
export const HideAnsweredContext = createContext(false);
/** Context to hide field questions (those marked required in the template) */
export const HideRequiredContext = createContext(false);
/** Context with the property_attributes row id, needed to build upload paths */
export const SurveyIdContext = createContext<string | null>(null);
